<template>
    <div class="game-page">
        <router-view ref="explainView"></router-view>

        <!-- <div class="kerst-ui"></div> -->

        <!-- <router-link class="skip-button black" to="/gegevens" tag="button">Doorgaan</router-link> -->
    </div>
</template>

<style lang="scss" scoped>
    .skip-button{
        position:absolute;
        top:0;
        right:0;
    }
</style>

<script>
    import { TimelineMax, TweenMax } from '@/vendor';

    export default {
        components: {
        },

        data()
        {
            return {
                explainView: null
            };
        },

        mounted()
        {
            TweenMax.to( createjs.Sound, 1, { volume: 0.5 });
        },

        methods: {
            getAnimateIn()
            {
                let tl = new TimelineMax();

                if( this.$refs.explainView )
                {
                    this.explainView = this.$refs.explainView;
                    tl.add( this.explainView.getAnimateIn() );
                }

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                if( this.explainView )
                {
                    if( this.explainView.getAnimateOut )
                    {
                        tl.add( this.explainView.getAnimateOut(), 0 );
                    }
                }

                if( this.$route.name === 'Landing' )
                {

                }

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Game.vue